module.exports = require("core-js/library/fn/object/freeze");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/freeze.js
// module id = 308
// module chunks = 0 1